import lodash_clone from 'lodash.clonedeep'
import lodash_shuffle from 'lodash.shuffle'

export const uniqid = (prefix='') => {
	return prefix + Math.random().toString(36).substr(2, 9) + Math.random().toString(36).substr(2, 9)
}

export const random = (max, min=0)  => {
	min = Math.ceil(min)
	max = Math.floor(max)
	return Math.floor(Math.random() * (max - min + 1)) + min
}

export const sample_by_probability = (arr)  => {
	let max = arr.reduce((acc, a) => { return a.probability + acc }, 0)
	if (max) {
		let r = random(max, 1)
		let n = 0
		let el = null
		for (let i in arr) {
			n += arr[i].probability
			if (n >= r) {
				el = arr[i]
				break
			}
		}
		if (el) return el
	}
	return false
}

export const sample = (arr)  => {
	if (arr.length >= 2) {
		let n = random(arr.length-1)
		return arr[n]
	} else
		return arr[0]
}

export const samples = (arr, nb)  => {
	let result = []
	if (arr.length >= 1) {
		if (nb > 1) {
			for (let i = 0; i < nb; i++) {
				let element = sample(arr.filter((el) => { return !result.includes(el) }))
				if (element) result.push(element)
			}

		} else
			result.push(sample(arr))
	}
	return result
}

export const clone = (obj)  => {
	return lodash_clone(obj)
}

export const shuffle = (obj)  => {
	return lodash_shuffle(obj)
}

export const shuffle_property = (arr, property)  => {
	let remaining = []
	arr.forEach((el) => { remaining.push(el[property]) })

	let els = []
	arr.forEach((el) => {
		if (remaining.length) {
			const p = sample(remaining)
			el[property] = p
			els.push(el)
			const index = remaining.findIndex((r) => { return r === p })
			if (index > -1) remaining.splice(index, 1)
		}
	})
	return els
}

export const throttle = (callback, delay) => {
	var last
	var timer
	return function () {
		var context = this
		var now = +new Date()
		var args = arguments
		if (last && now < last + delay) {
			// le délai n'est pas écoulé on reset le timer
			clearTimeout(timer)
			timer = setTimeout(function () {
				last = now
				callback.apply(context, args)
			}, delay)
		} else {
			last = now
			callback.apply(context, args)
		}
	}
}


export const debounce = (callback, delay) => {
	var timer
	return function(){
		var args = arguments
		var context = this
		clearTimeout(timer)
		timer = setTimeout(function(){
			callback.apply(context, args)
		}, delay)
	}
}

export const is_touch = () => {
	return 'ontouchstart' in document.documentElement
}